import React from 'react';
import { useTranslation } from 'react-i18next';

import { StyleSheet, Text, View } from '@react-pdf/renderer';
import { DIMENSIONALITY_VALUES } from 'constants/businessTool';
import { getColorObjectStyleByRecord } from 'PDF/helpers/documentStyle';
import { getDimensionalityForExamplePage } from 'PDF/pages/MarketAnalysis/helpers';

import { formatNumber } from 'helpers/numbers';

interface ISalesPlanFooterProps {
  numbers: number[];
  currencySymbol: string;
  unit: string;
  isExamplePage: boolean;
}

const colorIndexes = {
  green: 2,
  blue: 2,
  red: 2,
  blueGreen: 32,
  blueRed: 2,
  blueYellow: 32,
};

export const SalesPlanDetailsFooter: React.FC<ISalesPlanFooterProps> = ({
  numbers,
  unit,
  currencySymbol,
  isExamplePage = false,
}) => {
  const { t } = useTranslation();
  const getTotalRowContent = () => {
    return `${isExamplePage ? 'Total' : t('total')}, ${currencySymbol} ${unit === DIMENSIONALITY_VALUES.SINGLE ? '' : isExamplePage ? getDimensionalityForExamplePage(unit) : t(`pdfPages.mappings.financialPlan.dimensionality.${unit}`)}`;
  };

  return (
    <View style={[styles.row, getColorObjectStyleByRecord(colorIndexes, 'backgroundColor')]}>
      <View style={styles.titleWrap}>
        <Text style={[styles.info, styles.bold]}>{getTotalRowContent()}</Text>
      </View>
      {numbers.map((number, index) => (
        <View style={styles.ceil} key={index}>
          <Text style={[styles.info, styles.infoText, styles.bold]}>{formatNumber(+number, 1)}</Text>
        </View>
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  ceil: {
    width: '100%',
    paddingRight: '1px',
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    height: '16px',
    padding: '0 4px',
  },
  titleWrap: {
    minWidth: '154.64px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  info: {
    fontFamily: 'Noto',
    fontWeight: 300,
    fontSize: '9px',
    color: '#000',
  },
  infoText: {
    marginLeft: 'auto',
  },
  bold: {
    fontWeight: 600,
  },
});
